import config from '@/utils/Config'
import {get, post } from '@/utils/request'

export function getMusicListInfo(params = {}) {
    return get(config.BASE_URL, config.getMusicList, params)
}

export function saveMusic(params = {}, configParams) {
    return post(config.BASE_URL, config.saveMusicUrl, params, configParams)
}

export function getMusicListByPage(params = {}) {
    return post(config.BASE_URL, config.getMusicListByPage, params)
}

export function delMusic(params = { id: id }) {
    return post(config.BASE_URL, config.delMusicUrl, params)
}